import * as Activation from './activation';
import * as Analytics from './analytics';
import * as Assets from './assets';
import * as Attributes from './attributes';
import * as Auth from './auth';
import * as Blocks from './block';
import * as Catalogs from './catalogs';
import * as ContentBuilder from './contentBuilder';
import * as DataExtensions from './dataExtensions';
import * as Fallback from './fallback';
import * as Flags from './flags';
import * as Imports from './imports';
import * as ImportConfiguration from './importConfiguration';
import * as ProfileBrowser from './profileBrowser';
import * as Reports from './reports';
import * as Rules from './rules';
import * as Selections from './selections';
import * as Tags from './tags';

export default {
  ...Activation,
  ...Analytics,
  ...Assets,
  ...Attributes,
  ...Auth,
  ...Blocks,
  ...Catalogs,
  ...ContentBuilder,
  ...DataExtensions,
  ...Fallback,
  ...Flags,
  ...Imports,
  ...ImportConfiguration,
  ...ProfileBrowser,
  ...Reports,
  ...Rules,
  ...Selections,
  ...Tags
};
